const VistaprintAuth = require('@vp/auth');
const Globals = require('./globals');

let latestSignedInProfileId = undefined;
let latestAnonymousProfileId = undefined;

function init() {
    const auth = new VistaprintAuth.WebAuth();
    const identity = auth.getIdentity();
    if (identity && identity.profile) {
        setIdentity(identity);
    }

    window.addEventListener('userIdentity', handleIdentityUpdate);
}

function handleIdentityUpdate(e) {
    const identity = e.detail;
    if (identity && identity.profile) {
        setIdentity(identity);
    }
}

function setIdentity(identity) {
    const tracking = Globals.getTracking();
    const currentProfileId = getProfileId(identity.profile);
    if (identity.isSignedIn) {
        if (currentProfileId !== latestSignedInProfileId) {
            latestSignedInProfileId = currentProfileId;
            tracking.identify(currentProfileId);
        }
    } else {
        if (currentProfileId !== latestAnonymousProfileId) {
            latestAnonymousProfileId = currentProfileId;
            tracking.setAnonymousId(currentProfileId);
        }
    }
}

function getProfileId(profile) {
    return profile['https://claims.cimpress.io/canonical_id'];
}

module.exports = {
    init: init
};
